import { APIResponseWrapper, CB_BASE_PREFIX } from '@/api/types'
import { callBackend } from '@/api/callBackend'
import { ApiMethod } from 'common/src/api/types'
import {
    CfDeleteQaConversationRequest,
    CfDeleteQaConversationResponse,
    CfGetQaConversationRequest,
    CfGetQaConversationResponse,
    CfListQaConversationsRequest,
    CfListQaConversationsResponse,
    CfRespondQaBrowserRequestRequest,
    CfRespondQaBrowserRequestResponse,
    CfSendQaMessageRequest,
    CfSendQaMessageResponse,
    CfStartQaConversationRequest,
    CfStartQaConversationResponse,
} from 'common/src/api/contentFrontendVsContentBackend/qa'

const PREFIX = `${CB_BASE_PREFIX}/qa/`

export const startQaConversation = (
    request: CfStartQaConversationRequest
): APIResponseWrapper<CfStartQaConversationResponse> =>
    callBackend(PREFIX + 'startQaConversation', ApiMethod.POST, request)

export const sendQaMessage = (
    request: CfSendQaMessageRequest
): APIResponseWrapper<CfSendQaMessageResponse> =>
    callBackend(PREFIX + 'sendQaMessage', ApiMethod.POST, request)

export const getQaConversation = (
    request: CfGetQaConversationRequest
): APIResponseWrapper<CfGetQaConversationResponse> =>
    callBackend(PREFIX + 'getQaConversation', ApiMethod.GET, request)

export const listQaConversations = (
    request: CfListQaConversationsRequest
): APIResponseWrapper<CfListQaConversationsResponse> =>
    callBackend(PREFIX + 'listQaConversations', ApiMethod.GET, request)

export const deleteQaConversation = (
    request: CfDeleteQaConversationRequest
): APIResponseWrapper<CfDeleteQaConversationResponse> =>
    callBackend(PREFIX + 'deleteQaConversation', ApiMethod.POST, request)

export const respondQaBrowserRequest = (
    request: CfRespondQaBrowserRequestRequest
): APIResponseWrapper<CfRespondQaBrowserRequestResponse> =>
    callBackend(PREFIX + 'respondQaBrowserRequest', ApiMethod.POST, request)
